var map = {
	"./mobile/guestBgBorder.png": 8741,
	"./mobileBlack/guestBgBorder.png": 1969,
	"./pc/guestBgBorder.png": 5383,
	"./pcBlack/guestBgBorder.png": 2183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3650;